<section class="login-page" [class.step-otp]="step === 1">
  <article class="login-form-area">
    <div class="login-card">

      <ng-container [ngSwitch]="step">

        <!-- PASO 1: INGRESO DE CÓDIGO (OTP) -->
        <ng-container *ngSwitchCase="1">
          <h1 class="otp-title">ingresa el código de verificación</h1>

          <ng-container *ngIf="isQR; else otherContent">
            <p class="subtitle">
              Abre tu aplicación de autenticación en tu teléfono e ingresa el código generado para ingresar.
            </p>
          </ng-container>

          <ng-template #otherContent>
            <ng-container *ngIf="isEmail; else smsContent">
              <p class="subtitle">
                Por favor, ingresa el código que recibiste en tu correo electrónico para activar este método.
              </p>
            </ng-container>

            <ng-template #smsContent>
              <p class="subtitle">
                Por favor, ingresa el código que recibiste en tu teléfono celular vía SMS para activar este método.
              </p>
            </ng-template>
          </ng-template>

          <ng-container *ngIf="!!codeSet.length">
            <div class="container__otp" (keyup.enter)="VerifyCode()">
              <arc-otp-input
                [formControl]="codigoCtrl"
                [allowNumbersOnly]="false"
                [length]="largoCodigo"
                [isPasswordInput]="false"
                [disableAutoFocus]="false"
                placeholder=""
                [inputStyles]="{ width: '48px', height: '48px' }">
              </arc-otp-input>
            </div>
          </ng-container>

          <button class="btn-confirm" [disabled]="this.validationOTPCode()" (click)="VerifyCode()">
            Confirmar
          </button>

          <ng-container *ngIf="maxVerifyRetriesReached">
            <small class="max-retries">Has superado el máximo de intentos de verificación</small>
          </ng-container>

          <ng-container *ngIf="!!codeSet.length && !isQR">
            <small (click)="startCountdown($event)" [class.disabled]="isCountingDown" [class.max-retries]="maxRetriesReached" class="resend-link">
              {{MensajeConteo}}
            </small>
          </ng-container>
        </ng-container>

        <!-- PASO DEFAULT: SELECCIÓN DE MÉTODO -->
        <ng-container *ngSwitchDefault>
          <h1>Enviar código de verificación</h1>
          <p class="subtitle">Selecciona tu método de autenticación</p>

          <div class="field-group select-group">
            <mat-form-field appearance="outline" class="w-100 select-method-field">
              <mat-select [(ngModel)]="codeSet" (selectionChange)="onSelect($event)" placeholder="Seleccione método">
                <mat-option
                  *ngFor="let factores of appStateService.LoginResult && appStateService.LoginResult.twoFactorList || []"
                  [value]="factores.code">
                  {{factores.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <button class="btn-confirm" [disabled]="!codeSet" (click)="SenCode()">
            Aceptar
          </button>
        </ng-container>

      </ng-container>

    </div>
  </article>
</section>